var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState, useMemo } from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { get } from 'lodash';
import { Business, ExpandLess, ExpandMore, LocalShipping, } from '@material-ui/icons';
import { Collapse } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { usePhoneView } from '@michelin/acid-components';
import { MechanicalCareIcon } from '../../../images/icons/MechanicalCareIcon';
import { FleetOrderIcon } from '../../../images/icons/FleetOrderIcon';
import HitDetail from './HitDetail';
import { GLOBAL_SEARCH_ITEMS, } from '../../../types/GlobalSearch';
import { isDark } from '../../../types/Theme';
var useStyles = makeStyles(function (theme) {
    var _a, _b;
    return createStyles({
        headerResult: {
            backgroundColor: theme.palette.secondary.dark,
            color: theme.palette.secondary.contrastText,
            borderBottom: "solid 1px ".concat(theme.palette.secondary.dark),
            fontSize: '14px',
            padding: '5px 10px',
            textTransform: 'uppercase',
            fontWeight: 'bold',
            display: 'flex',
        },
        headerResultDark: {
            backgroundColor: theme.palette.background.default,
            color: 'white',
            borderBottom: "solid 1px ".concat(theme.palette.primary.dark),
        },
        item: (_a = {
                display: 'inline-block',
                lineHeight: '24px',
                paddingLeft: 10,
                paddingRight: 10
            },
            _a[theme.breakpoints.down('xs')] = {
                width: '85%',
            },
            _a),
        expandIcon: {
            float: 'right',
        },
        hit: (_b = {
                cursor: 'pointer',
                fontSize: '12px'
            },
            _b[theme.breakpoints.down('xs')] = {
                padding: '10px !important',
            },
            _b[theme.breakpoints.up('sm')] = {
                padding: '6px 6px 6px 25px !important',
            },
            _b),
        hitSelected: {
            color: '#ffffff',
            backgroundColor: '#0093f8',
        },
    });
});
var HitListItems = function (_a) {
    var items = _a.items, itemsType = _a.itemsType, title = _a.title, selectedHit = _a.selectedHit, setSelectHit = _a.setSelectHit;
    var classes = useStyles();
    var _b = __read(useState(true), 2), open = _b[0], setOpen = _b[1];
    var t = useTranslation().t;
    var phoneView = usePhoneView();
    var handleClick = function () {
        setOpen(!open);
    };
    var icon = useMemo(function () {
        if (itemsType === GLOBAL_SEARCH_ITEMS.FLEET_ORDER_ITEM || itemsType === GLOBAL_SEARCH_ITEMS.URBAN_ORDER_ITEM) {
            return React.createElement(FleetOrderIcon, { fill: true });
        }
        if (itemsType === GLOBAL_SEARCH_ITEMS.MECHANICAL_CARE_ITEM) {
            return React.createElement(MechanicalCareIcon, null);
        }
        if (itemsType === GLOBAL_SEARCH_ITEMS.ONCALL_ITEM) {
            return React.createElement(LocalShipping, { color: "primary" });
        }
        return React.createElement(Business, { color: "primary" });
    }, [itemsType]);
    var getHitKey = function (hit) {
        if (itemsType === GLOBAL_SEARCH_ITEMS.CONTACT_ITEM) {
            return "hit-".concat(hit.hash_key);
        }
        return "hit-".concat(hit.id);
    };
    var getHitDescription = function (hit) {
        switch (itemsType) {
            case GLOBAL_SEARCH_ITEMS.FLEET_ORDER_ITEM:
            case GLOBAL_SEARCH_ITEMS.URBAN_ORDER_ITEM:
                return "".concat(t('Order'), " ").concat(hit.id, " ");
            case GLOBAL_SEARCH_ITEMS.CONTACT_ITEM:
                return "".concat(hit.first_name, " ").concat(hit.last_name);
            case GLOBAL_SEARCH_ITEMS.MECHANICAL_CARE_ITEM:
                return "#".concat(hit.id, " VIN: ").concat(get(hit, 'assets.0.vin') || '-');
            case GLOBAL_SEARCH_ITEMS.ONCALL_ITEM:
                return "#".concat(hit.id);
            default: return '';
        }
    };
    var onClickItem = function (hit) {
        if (phoneView && checkHitEquality(hit)) {
            setSelectHit(undefined);
            return;
        }
        setSelectHit({ type: itemsType, data: hit });
    };
    var checkHitEquality = function (hit) {
        var _a, _b;
        if (hit.id)
            return hit.id === ((_a = selectedHit === null || selectedHit === void 0 ? void 0 : selectedHit.data) === null || _a === void 0 ? void 0 : _a.id);
        // For contacts
        if (hit.hash_key)
            return hit.hash_key === ((_b = selectedHit === null || selectedHit === void 0 ? void 0 : selectedHit.data) === null || _b === void 0 ? void 0 : _b.hash_key);
        return false;
    };
    var dark = isDark();
    return (React.createElement("li", { key: "hit-group-".concat(itemsType.valueOf) },
        React.createElement("div", { className: "".concat(classes.headerResult, " ").concat(dark ? classes.headerResultDark : ''), onClick: handleClick },
            React.createElement("div", { style: { width: '90%' } }, title),
            items.length > 0 && (React.createElement(React.Fragment, null, open ? (React.createElement(ExpandLess, { className: classes.expandIcon })) : (React.createElement(ExpandMore, { className: classes.expandIcon }))))),
        items.length > 0 ? (React.createElement(Collapse, { in: open, timeout: "auto", unmountOnExit: true },
            React.createElement("ul", null, items.map(function (hit) { return (React.createElement("li", { className: "".concat(classes.hit, " ").concat(checkHitEquality(hit) && !phoneView ? classes.hitSelected : ''), key: getHitKey(hit), onClick: function () { return onClickItem(hit); } },
                React.createElement("div", { style: { display: 'flex' } },
                    React.createElement("div", { style: { display: 'flex', width: '90%' } },
                        icon,
                        React.createElement("strong", { className: classes.item }, getHitDescription(hit))),
                    phoneView && (React.createElement(React.Fragment, null, checkHitEquality(hit) ? (React.createElement(ExpandLess, { className: classes.expandIcon })) : (React.createElement(ExpandMore, { className: classes.expandIcon }))))),
                phoneView && (React.createElement(Collapse, { in: checkHitEquality(hit), timeout: "auto", unmountOnExit: true },
                    React.createElement(HitDetail, { selectedHit: selectedHit }))))); })))) : (React.createElement("ul", null,
            React.createElement("li", { className: classes.hit },
                React.createElement("div", { style: { display: 'flex' } },
                    icon,
                    React.createElement("span", { className: classes.item }, t('No items found'))))))));
};
export default HitListItems;
//# sourceMappingURL=HitListItems.js.map